module.exports = __webpack_public_path__ + "img/vertical_4_7_7005.37a4a986.png";